import { c as _c } from "react-compiler-runtime";
import { useCallback, useContext } from 'react';
import { APP_NAME, COMMENTS_FILTER, CTA_URL, HIDE_EMBEDDED_COMMENTS, IS_COMMENT_MODE_ACTIVE, IS_EMBEDDED_COMMENTS_ENABLED, IS_OPEN, MODULES_WITH_REPLIES, OBJECT_ID, OBJECT_TYPE, TAB, SELECTED_ASSET, COMMENT_THREAD, ASSETS_LAST_UPDATED, ENABLED_FEATURES, IS_EMBEDDED_POPOVER_OPEN, EMBEDDED_POPOVER_PLACEMENT, EMBEDDED_COMMENT_COORDINATES, EMBEDDED_MODULE_ID, EMBEDDED_META_DESCRIPTION, IS_EMBEDDED_OPEN_FROM_COMMENT_MODE, COMMENTABLE_AREA_CLICK_COORDINATES, DELETE_COMMENT_REQUEST, EMBEDDED_POPOVER_ANCHOR_SELECTOR } from '../constants/CollaborationSidebarStateProperties';
import CollaborationSidebarStateContext from '../contexts/CollaborationSidebarStateContext';
import { getSanitizedTab } from '../utils/tab';
import { deleteCommentOnModuleAction, getEmptyCollaborationSidebarStateContext } from '../utils';
export default function useCollaborationSidebarState(t0) {
  "use memo";

  const $ = _c(41);
  const {
    allowNoContext
  } = t0 === undefined ? {} : t0;
  const contextVal = useContext(CollaborationSidebarStateContext);
  if (!contextVal && !allowNoContext) {
    throw new Error("Using useCollaborationSidebarState outside of a CollaborationSidebarStateContext");
  }
  let t1;
  if ($[0] !== contextVal) {
    t1 = contextVal || getEmptyCollaborationSidebarStateContext();
    $[0] = contextVal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = t1;
  const t2 = collaborationSidebarState[APP_NAME];
  const t3 = collaborationSidebarState[ENABLED_FEATURES];
  const t4 = collaborationSidebarState[OBJECT_TYPE];
  const t5 = collaborationSidebarState[OBJECT_ID];
  const t6 = collaborationSidebarState[CTA_URL];
  const t7 = collaborationSidebarState[IS_EMBEDDED_COMMENTS_ENABLED];
  const t8 = collaborationSidebarState[IS_OPEN];
  const t9 = collaborationSidebarState[TAB];
  const t10 = collaborationSidebarState[MODULES_WITH_REPLIES];
  const t11 = collaborationSidebarState[IS_COMMENT_MODE_ACTIVE];
  const t12 = collaborationSidebarState[HIDE_EMBEDDED_COMMENTS];
  const t13 = collaborationSidebarState[SELECTED_ASSET];
  const t14 = collaborationSidebarState[COMMENT_THREAD];
  const t15 = collaborationSidebarState[COMMENTS_FILTER];
  const t16 = collaborationSidebarState[ASSETS_LAST_UPDATED];
  const t17 = collaborationSidebarState[IS_EMBEDDED_POPOVER_OPEN];
  const t18 = collaborationSidebarState[EMBEDDED_POPOVER_PLACEMENT];
  const t19 = collaborationSidebarState[EMBEDDED_COMMENT_COORDINATES];
  const t20 = collaborationSidebarState[EMBEDDED_MODULE_ID];
  const t21 = collaborationSidebarState[EMBEDDED_POPOVER_ANCHOR_SELECTOR];
  const t22 = collaborationSidebarState[EMBEDDED_META_DESCRIPTION];
  const t23 = collaborationSidebarState[IS_EMBEDDED_OPEN_FROM_COMMENT_MODE];
  const t24 = collaborationSidebarState[COMMENTABLE_AREA_CLICK_COORDINATES];
  const t25 = collaborationSidebarState[DELETE_COMMENT_REQUEST];
  let t26;
  if ($[2] !== onUpdateCollaborationSidebarState) {
    t26 = tab => onUpdateCollaborationSidebarState({
      [IS_OPEN]: true,
      [TAB]: getSanitizedTab(tab)
    });
    $[2] = onUpdateCollaborationSidebarState;
    $[3] = t26;
  } else {
    t26 = $[3];
  }
  const t27 = t26;
  let t28;
  if ($[4] !== onUpdateCollaborationSidebarState) {
    t28 = () => onUpdateCollaborationSidebarState({
      [IS_OPEN]: false
    });
    $[4] = onUpdateCollaborationSidebarState;
    $[5] = t28;
  } else {
    t28 = $[5];
  }
  const t29 = t28;
  let t30;
  if ($[6] !== onUpdateCollaborationSidebarState) {
    t30 = hideEmbeddedComments => onUpdateCollaborationSidebarState({
      [HIDE_EMBEDDED_COMMENTS]: hideEmbeddedComments
    });
    $[6] = onUpdateCollaborationSidebarState;
    $[7] = t30;
  } else {
    t30 = $[7];
  }
  const t31 = t30;
  let t32;
  if ($[8] !== onUpdateCollaborationSidebarState) {
    t32 = moduleId => {
      onUpdateCollaborationSidebarState(deleteCommentOnModuleAction(moduleId));
    };
    $[8] = onUpdateCollaborationSidebarState;
    $[9] = t32;
  } else {
    t32 = $[9];
  }
  const t33 = t32;
  let t34;
  if ($[10] !== collaborationSidebarState || $[11] !== onUpdateCollaborationSidebarState || $[12] !== t10 || $[13] !== t11 || $[14] !== t12 || $[15] !== t13 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16 || $[19] !== t17 || $[20] !== t18 || $[21] !== t19 || $[22] !== t2 || $[23] !== t20 || $[24] !== t21 || $[25] !== t22 || $[26] !== t23 || $[27] !== t24 || $[28] !== t25 || $[29] !== t27 || $[30] !== t29 || $[31] !== t3 || $[32] !== t31 || $[33] !== t33 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t34 = {
      collaborationSidebarState,
      onUpdateCollaborationSidebarState,
      appName: t2,
      enabledFeatures: t3,
      objectType: t4,
      objectId: t5,
      ctaUrl: t6,
      isEmbeddedCommentingEnabled: t7,
      isOpen: t8,
      tab: t9,
      modulesWithReplies: t10,
      replyCounts: collaborationSidebarState.replyCounts,
      isCommentModeActive: t11,
      hideEmbeddedComments: t12,
      selectedChildAsset: t13,
      commentThread: t14,
      commentsFilter: t15,
      assetsLastUpdated: t16,
      isEmbeddedPopoverOpen: t17,
      embeddedPopoverPlacement: t18,
      embeddedCommentCoordinates: t19,
      embeddedModuleID: t20,
      embeddedPopoverAnchorSelector: t21,
      embeddedMetaDescription: t22,
      isEmbeddedOpenFromCommentMode: t23,
      commentableAreaClickCoordinates: t24,
      deleteCommentRequest: t25,
      openSidebar: t27,
      closeSidebar: t29,
      setHideEmbeddedComments: t31,
      deleteCommentOnModule: t33
    };
    $[10] = collaborationSidebarState;
    $[11] = onUpdateCollaborationSidebarState;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t2;
    $[23] = t20;
    $[24] = t21;
    $[25] = t22;
    $[26] = t23;
    $[27] = t24;
    $[28] = t25;
    $[29] = t27;
    $[30] = t29;
    $[31] = t3;
    $[32] = t31;
    $[33] = t33;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t34;
  } else {
    t34 = $[40];
  }
  return t34;
}